'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BarGraph = function (_PureComponent) {
  _inherits(BarGraph, _PureComponent);

  function BarGraph() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BarGraph);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BarGraph.__proto__ || Object.getPrototypeOf(BarGraph)).call.apply(_ref, [this].concat(args))), _this), _this.getClassName = function () {
      return;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BarGraph, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          percentage = _props.percentage,
          className = _props.className,
          otherProps = _objectWithoutProperties(_props, ['title', 'percentage', 'className']);

      return _react2.default.createElement(
        'div',
        _extends({ className: 'BarGraph ' + className }, otherProps),
        _react2.default.createElement(
          'span',
          { className: 'BarGraph-title' },
          title
        ),
        _react2.default.createElement(
          'span',
          { className: 'BarGraph-value' },
          percentage,
          '%'
        ),
        _react2.default.createElement(
          'div',
          { className: 'BarGraph-bar-holder' },
          _react2.default.createElement('div', { className: 'BarGraph-bar', style: { width: percentage + '%' } })
        )
      );
    }
  }]);

  return BarGraph;
}(_react.PureComponent);

BarGraph.propTypes = {
  title: _propTypes2.default.string.isRequired,
  percentage: _propTypes2.default.number.isRequired,
  className: _propTypes2.default.string.isRequired
};

BarGraph.defaultProps = {
  className: ''
};

exports.default = BarGraph;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Visualizations/BarGraph.js
// module id = 664
// module chunks = 0